import { DefaultTheme } from '@byte-coach/admin-ui-components';
import { createTheme } from '@mui/material';

export const appTheme = createTheme({
  ...DefaultTheme,
  palette: {
    ...DefaultTheme.palette,
    background: {
      ...DefaultTheme.palette.background,
      default: '#F5F5F5',
    },
    primary: {
      ...DefaultTheme.palette.primary,
      400: '#ED3D46',
      500: '#E32A33',
    },
    black: {
      ...DefaultTheme.palette.black,
      main: '#262222',
    },
  },
  typography: {
    h6: {
      fontSize: '20px',
      lineHeight: '24px',
    },
    subtitle2: {
      fontSize: '16px',
      lineHeight: '24px',
    },
    body2: {
      fontSize: '14px',
      lineHeight: '20px',
    },
  },
});
